
import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const ViewGeneralLedgerCodes = ({ glCode }) => {
  if (!glCode) {
    return null;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3, marginTop: 3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        GL Code Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            GL Code: {glCode.glCode}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body2">
            GL Account Description: {glCode.glAccountDescription}
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ViewGeneralLedgerCodes;
